import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _isEqual from 'lodash/isEqual';
import ReactSimpleDropdown, {
  DropdownTrigger,
  DropdownContent,
} from 'react-simple-dropdown';

import { filterOptionsType } from 'types';
import FilterMenuItemRadio from './components/FilterMenuItemRadio';
import FilterMenuItemSwitch from './components/FilterMenuItemSwitch';
import FilterMatchedMenuItem from './components/FilterMatchedMenuItem';

import './style.scss';

export default class FilterMenu extends Component {
  static propTypes = {
    filterOptions: PropTypes.arrayOf(filterOptionsType).isRequired,
    modelName: PropTypes.string.isRequired,
    onFilter: PropTypes.func.isRequired,
    annotationsIsLoading: PropTypes.bool,
    className: PropTypes.string,
  };

  shouldComponentUpdate(nextProps) {
    return (
      !_isEqual(nextProps.filterOptions, this.props.filterOptions) ||
      !_isEqual(nextProps.modelName, this.props.modelName) ||
      !_isEqual(nextProps.annotationsIsLoading, this.props.annotationsIsLoading)
    );
  }

  handleFilter = obj => {
    this.props.onFilter(obj);
    this.dropdown.hide();
  };

  handleFilterArchived = (value, name) => {
    this.handleFilter({
      archived: value,
      name,
      value,
    });
  };

  handleClick = (item, name) => {
    this.handleFilter({
      [name]: item.value,
      value: item.value,
      name,
    });
  };

  mapRef = el => {
    this.dropdown = el;
  };

  renderItem(item) {
    if (item.type === 'radiobutton') {
      return (
        <div
          key={item.name}
          data-test={`radiobutton-${item.name}`}
          styleName="wrap"
        >
          <FilterMenuItemRadio
            handleClick={this.handleClick}
            item={item}
            name={item.name}
            options={item.options}
            value={item.value}
          />
        </div>
      );
    }
    if (item.type === 'matched') {
      return (
        <div key={item.name} styleName="wrap" data-test= "filters-rules" >
          <FilterMatchedMenuItem
            key={item.name}
            data-test={`wrap-${item.name}`}
            handleClick={this.handleClick}
            item={item}
            name={item.name}
            options={item.options}
            value={item.value}
          />
        </div>
      );
    }
    if (item.type === 'switch') {
      return (
        <FilterMenuItemSwitch
          key={item.name}
          label={item.label}
          name={item.name}
          options={item.options}
          value={item.value}
          onToggle={this.handleFilterArchived}
        />
      );
    }
    return null;
  }

  render() {
    const { className, filterOptions, annotationsIsLoading } = this.props;
    return (
      <ReactSimpleDropdown
        ref={this.mapRef}
        className={className}
        disabled={annotationsIsLoading}
        styleName="filter-menu"
      >
        <DropdownTrigger
          data-test="trigger-filter-menu"
          disabled={annotationsIsLoading}
        >
          <i className="icon-filter" />
          Filters
        </DropdownTrigger>
        <DropdownContent>
          {filterOptions.map(item => this.renderItem(item))}
        </DropdownContent>
      </ReactSimpleDropdown>
    );
  }
}
